import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AgenceService } from 'src/app/Service/agence.service';
import { Global } from 'src/app/Service/global.service';
import { SharedService } from 'src/app/Service/shared.service';
import * as _ from 'lodash';
declare var $: any;


@Component({
  selector: 'app-rapports-annuels',
  templateUrl: './rapports-annuels.component.html',
  styleUrls: ['./rapports-annuels.component.scss']
})
export class RapportsAnnuelsComponent implements OnInit {
  langue = '';
  constructor(private global: Global, private service: AgenceService, private shared: SharedService) { }
  bloc = {
    Titre: "",
    Contenu: ""
  }
  rapports = [];
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.langue = lg.code;
      this.shared.getBlocDescriptionByCode(lg.url, "RapportsAnnuels1").subscribe(data => {
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })
      this.service.getRapport(lg.url).subscribe(data => {
        this.rapports = data["value"]
        this.rapports = _.orderBy(this.rapports, 'RapportAnnuelAnnee', 'desc');
      }, err => {
        this.rapports = [];
      })
    })
  }

}


